module.exports = __webpack_public_path__ + "img/scabieuse_des_pres.f5f6a23e.jpg";